export const FETCH_AMIGO_PAGUITOS_LOAN_DETAILS =
  "FETCH_AMIGO_PAGUITOS_LOAN_DETAILS";
export const FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_SUCCESS =
  "FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_SUCCESS";
export const FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_ERROR =
  "FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_ERROR";

export const FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_RESET =
  "FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_RESET";

export const fetchAmigoPaguitosLoanDetails = (loanId) => {
  return {
    type: FETCH_AMIGO_PAGUITOS_LOAN_DETAILS,
    loanId,
  };
};

export const fetchAmigoPaguitosLoanDetailsSuccess = (payload) => {
  console.log("ac payload", payload);
  return {
    type: FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_SUCCESS,
    payload,
  };
};

export const fetchAmigoPaguitosLoanDetailsError = (payload,err) => {
  return {
    type: FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_ERROR,
    payload,
    err,
  };
};

export const fetchAmigoPaguitosLoanDetailsReset = () => {
  return {
    type: FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_RESET,
  };
};
